export default __webpack_public_path__ + "static/media/gallery1.90fbc905.jpg";